// Client-side deep-link routing for the native WebView.
//
// The native app (iOS/Android) does NOT reload the WebView for deep links or
// push-notification taps. Instead it calls window.tossitNavigate(path) once the
// WebView reports "loaded". There is NO retry on the native side — if the global
// isn't defined yet when native calls it, the deep link is silently dropped.
//
// So the global is installed SYNCHRONOUSLY at app boot (from index.js, before
// React renders). React Router's navigate() isn't available that early, so any
// path that arrives before the router mounts is queued and flushed the instant
// the navigator registers (see registerDeepLinkNavigator).

let _navigate = null;
let _pending = [];

// Called by a component inside the Router (DeepLinkBridge) once useNavigate is
// available. Flushes any deep links that raced ahead of hydration.
export const registerDeepLinkNavigator = (navigateFn) => {
    _navigate = navigateFn;
    if (_pending.length) {
        const queued = _pending;
        _pending = [];
        queued.forEach((path) => {
            try { _navigate(path); } catch (e) { /* noop */ }
        });
    }
};

// Install window.tossitNavigate — ONLY inside the native WebView. A plain browser
// tab never gets this global. Idempotent.
export const installDeepLinkBridge = () => {
    if (typeof window === 'undefined') return;
    if (!(window.TossitNative && window.TossitNative.isAvailable)) return;
    if (window.tossitNavigate) return;
    window.tossitNavigate = (path) => {
        if (typeof path !== 'string' || !path) return;
        if (_navigate) {
            try { _navigate(path); } catch (e) { /* noop */ }
        } else {
            _pending.push(path); // router not mounted yet — flush on register
        }
    };
};
